<section class="reservation" id="reservation">
  <div class="container">
    <div class="reservation__wrapper">
      <div class="reservation__info fade-in">
        <span class="section-subtitle">Foglalás</span>
        <h2 class="section-title">Foglalj asztalt nálunk Pákozdon</h2>
        <p>
          Szeretettel várunk a Kanyar Büfében — Pákozdon, a Velencei-tó partján.
          Foglald le asztalodat online: pacalpörkölt, frissensültek vagy egy hideg
          cseh csapolt sör mellett tölts el egy kellemes délutánt. Nagyobb társaságokra
          és különleges alkalmakra egyedi ajánlatot is készítünk.
        </p>
        <div class="reservation__details">
          <div class="detail-item">
            <span class="detail-icon">📍</span>
            <div>
              <strong>Cím</strong>
              <span>Pákozd, Dinnyési út 2./A</span>
            </div>
          </div>
          <div class="detail-item">
            <span class="detail-icon">📞</span>
            <div>
              <strong>Telefon</strong>
              <span>+36 20 592 0000</span>
            </div>
          </div>
          <div class="detail-item">
            <span class="detail-icon">🕐</span>
            <div>
              <strong>Nyitvatartás</strong>
              <span>H–V: 8:00 – 18:00</span>
            </div>
          </div>
        </div>
      </div>

      <div class="reservation__form-wrapper fade-in">
        @if (submitted()) {
          <div class="reservation__success">
            <span class="success-icon">✓</span>
            <h3>Sikeres foglalás!</h3>
            <p>Foglalásod visszaigazolását hamarosan megkapod e-mailben.</p>
          </div>
        } @else {
          <form [formGroup]="reservationForm" (ngSubmit)="onSubmit()" class="reservation__form">
            <div class="form-row">
              <div class="form-group">
                <label for="date">Dátum</label>
                <input type="date" id="date" formControlName="date" />
                @if (f['date'].touched && f['date'].errors) {
                  <span class="form-error">Kérjük válassz dátumot</span>
                }
              </div>
              <div class="form-group">
                <label for="time">Időpont</label>
                <select id="time" formControlName="time">
                  @for (slot of timeSlots; track slot) {
                    <option [value]="slot">{{ slot }}</option>
                  }
                </select>
                @if (f['time'].touched && f['time'].errors) {
                  <span class="form-error">Kérjük válassz időpontot</span>
                }
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label for="seating">Beltér vagy Terasz?</label>
                <select id="seating" formControlName="seating">
                  @for (opt of seatingOptions; track opt.value) {
                    <option [value]="opt.value">{{ opt.label }}</option>
                  }
                </select>
              </div>
              <div class="form-group">
                <label for="guests">Hány fő?</label>
                <input type="number" id="guests" formControlName="guests" min="1" max="20" />
                @if (f['guests'].touched && f['guests'].errors) {
                  <span class="form-error">1–20 fő között</span>
                }
              </div>
            </div>

            <div class="form-group">
              <label for="name">Név</label>
              <input type="text" id="name" formControlName="name" placeholder="Teljes neved" />
              @if (f['name'].touched && f['name'].errors) {
                <span class="form-error">Kérjük add meg a neved</span>
              }
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" id="email" formControlName="email" placeholder="pelda@email.com" />
              @if (f['email'].touched && f['email'].errors) {
                <span class="form-error">Érvényes email címet adj meg</span>
              }
            </div>

            <div class="form-group">
              <label for="phone">Telefonszám</label>
              <input type="tel" id="phone" formControlName="phone" placeholder="+36 30 123 4567" />
              @if (f['phone'].touched && f['phone'].errors) {
                <span class="form-error">Érvényes telefonszámot adj meg</span>
              }
            </div>

            <button type="submit" class="btn-primary reservation__submit">
              Asztal foglalása
            </button>
          </form>
        }
      </div>
    </div>
  </div>
</section>
